import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities, updateSupportList, uploadEntity } from './support.reducer';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { message, Space, Upload, Row, Table, Button, Tag } from 'antd';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { values } from 'lodash';

export const Support = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const supportList = useAppSelector(state => state.support.entities);
  const loading = useAppSelector(state => state.support.loading);
  const totalItems = useAppSelector(state => state.support.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: 150,
      render: text => <a>{text}</a>,
    },
    {
      title: 'NFC1',
      dataIndex: 'nfc1',
      key: 'nfc1',
    },
    {
      title: 'NFC2',
      dataIndex: 'nfc2',
      key: 'nfc2',
      width: 200,
    },
    {
      title: 'NFC3',
      dataIndex: 'nfc3',
      key: 'nfc3',
      width: 200,
    },
    {
      title: 'QRCODE',
      dataIndex: 'qrcode',
      key: 'qrcode',
      width: 200,
    },
    {
      title: 'Status',
      dataIndex: 'activated',
      key: 'activated',
      width: 200,
      render: activated => (activated ? <Tag color="green">Activé</Tag> : <Tag color="red">Désactivé</Tag>),
    },
  ];

  const dataSource = supportList.map((support, i) => ({
    id: support.id,
    nfc1: support.nfc1,
    nfc2: support.nfc2,
    nfc3: support.nfc3,
    qrcode: support.qrcode,
    activated: support.activated,
  }));

  const prop = {
    onRemove() {
      setFile(null);
      setUploading(false);
    },
    beforeUpload(fil) {
      setFile(fil);
      return false;
    },

    file,
  };

  const handleUpload = () => {
    const formData = new FormData();
    formData.append('file', file);
    setFile(null);
    setUploading(true);
    dispatch(uploadEntity(formData)).then(() => {
      setUploading(false);
      prop.onRemove();
    });
  };
  const handleUpdate = () => {
    dispatch(updateSupportList({}));
  };

  const { match } = props;

  return (
    <div className="responsive">
      <h2>
        Gestion des supports
        <div style={{ textAlign: 'right' }}>
          <Button type="primary" className="btn btn-info jh-create-entity" onClick={handleUpdate} style={{ marginTop: 16 }}>
            reset Status
          </Button>{' '}
          &nbsp;
          <Upload {...prop}>
            <span className="btn btn-info jh-create-entity" id="jh-create-entity">
              <FontAwesomeIcon icon={faUpload} />
              &nbsp; Importer un fichier
            </span>{' '}
          </Upload>
          <Button type="primary" onClick={handleUpload} disabled={file == null} loading={uploading} style={{ marginTop: 16 }}>
            {uploading ? 'Chargement...' : 'Charger le fichier'}
          </Button>
        </div>
      </h2>
      <div className="table-responsive">
        {supportList && supportList.length > 0 ? (
          <Table dataSource={dataSource.reverse()} columns={columns} pagination={{ pageSize: 20 }} />
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="korischoolApp.support.home.notFound">No Supports found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={supportList && supportList.length > 0 ? 'table-responsive' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Support;
